const Filters = () => {
  return (
    <>
      <div
        className="nav flex-column nav-pills border-end me-3"
        id="v-pills-tab"
        role="tablist"
        aria-orientation="vertical"
      >
        <button
          className="nav-link active border-bottom p-3 text-start mb-2"
          id="v-pills-category-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-category"
          type="button"
          role="tab"
          aria-controls="v-pills-category"
          aria-selected="false"
        >
          Category
        </button>
        <button
          className="nav-link  border-bottom p-3 text-start mb-2"
          id="v-pills-sort-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-sort"
          type="button"
          role="tab"
          aria-controls="v-pills-sort"
          aria-selected="true"
        >
          Sort By
        </button>
        <button
          className="nav-link  border-bottom p-3 text-start mb-2"
          id="v-pills-gender-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-gender"
          type="button"
          role="tab"
          aria-controls="v-pills-gender"
          aria-selected="true"
        >
          Gender
        </button>

        <button
          className="nav-link border-bottom p-3 text-start mb-2"
          id="v-pills-price-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-price"
          type="button"
          role="tab"
          aria-controls="v-pills-price"
          aria-selected="false"
        >
          Price
        </button>
        <button
          className="nav-link border-bottom p-3 text-start mb-2"
          id="v-pills-brands-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-brands"
          type="button"
          role="tab"
          aria-controls="v-pills-brands"
          aria-selected="false"
        >
          Brands
        </button>
        <button
          className="nav-link border-bottom p-3 text-start mb-2"
          id="v-pills-occasion-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-occasion"
          type="button"
          role="tab"
          aria-controls="v-pills-occasion"
          aria-selected="false"
        >
          Occasion
        </button>
        <button
          className="nav-link border-bottom p-3 text-start mb-2"
          id="v-pills-discounts-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-discounts"
          type="button"
          role="tab"
          aria-controls="v-pills-discounts"
          aria-selected="false"
        >
          Discount
        </button>
        <button
          className="nav-link border-bottom p-3 text-start mb-2"
          id="v-pills-colors-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-colors"
          type="button"
          role="tab"
          aria-controls="v-pills-colors"
          aria-selected="false"
        >
          Colors
        </button>
        <button
          className="nav-link border-bottom p-3 text-start mb-2"
          id="v-pills-size-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-size"
          type="button"
          role="tab"
          aria-controls="v-pills-size"
          aria-selected="false"
        >
          Size & Fit
        </button>
        <button
          className="nav-link border-bottom p-3 text-start mb-2"
          id="v-pills-tags-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-tags"
          type="button"
          role="tab"
          aria-controls="v-pills-tags"
          aria-selected="false"
        >
          Tags
        </button>
        <button
          className="nav-link border-bottom p-3 text-start mb-0"
          id="v-pills-ratings-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-ratings"
          type="button"
          role="tab"
          aria-controls="v-pills-ratings"
          aria-selected="false"
        >
          Rating
        </button>
      </div>
    </>
  );
};

export default Filters;
